<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Claim a QR Code</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Code ID</mat-label>
    <input
      matInput
      [(ngModel)]="paper_id"
      placeholder="Code ID"
      maxlength="8"
      minlength="8"
      #paperInput="ngModel"
    />
    <mat-error *ngIf="paperInput.invalid">
      Code IDs should be 8 characters long.
    </mat-error>
  </mat-form-field>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
    <button
      mat-raised-button
      color="primary"
      class="my-2 ml-1 mr-2"
      (click)="claim()"
      [disabled]="paperInput.invalid || !paper_id || inProgress">
      <mat-icon>check</mat-icon>
      Claim
    </button>

  <button mat-raised-button class="my-2 ml-1 ml-sm-auto mr-0" [mat-dialog-close]="false" color="secondary">
    <mat-icon>close</mat-icon>
    Cancel
  </button>
</mat-dialog-actions>
